<div class="sidenav-container tw-flex tw-flex-col">

  <mat-toolbar color="primary"
    class="sidenav-toolbar mat-elevation-z2">
    <div class="tw-flex tw-flex-row tw-w-full">
      <img src="assets/img/glide-logo.svg"
        class="gd-sidenav-logo tw-flex tw-self-center">
        <span class="tw-flex-1 tw-box-border"><!-- fill space --></span>
        <div class="tw-hidden sm:tw-flex tw-self-center">
          <button mat-icon-button
            (click)="toggleIconSidenav()">
            <mat-icon class="icon-sidenav-toggle fade-in-on-icon-sidenav"
              [class.rotate]="isIconSidenav()"
              fontSet="fal"
            fontIcon="fa-angle-left"></mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar>
    <div class="sidenav-scrollbar-container tw-flex tw-flex-col">
      <mat-nav-list class="sidenav-list sidenav-toplevel tw-flex tw-flex-col">
        @for (item of items; track item) {
          <gd-sidenav-item
            [item]="item"
            [currentlyActiveSidenavItem]="activeItemsMap"
          (click)="sendMixPanelEvent($event, item)"></gd-sidenav-item>
        }
      </mat-nav-list>

      <div class="sidenav-container__environment-notes">
        @if (version) {
          <span
            class="fade-in-on-icon-sidenav sidenav-container__glide-version"
          i18n>v {{version}}</span>
        }
        <span class="fade-in-on-icon-sidenav sidenav-container__environment-notes-text">{{ envNotes }}</span>
      </div>
    </div>
  </div>
